import { FC, SVGProps } from 'react';

const AISummaryIcon: FC<SVGProps<SVGSVGElement> & { size?: number }> = ({ color = '#7A7A7A', size = 20, ...props }) => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width={size} height={size} viewBox="0 0 20 20" fill="none" {...props}>
      <path d="M2.5 15.9566H8.43133" stroke={color} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
      <path d="M2.5 11.9857H6.19354" stroke={color} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
      <path d="M2.5 4.04297H17.4993" stroke={color} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
      <path d="M2.5 8.01434H8.34258" stroke={color} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
      <path
        d="M12.0933 14.6825L11.9723 14.3549C11.5158 13.1195 10.5432 12.1454 9.30959 11.6883L8.98242 11.5671L9.30959 11.4458C10.5432 10.9887 11.5158 10.0147 11.9723 8.77927L12.0933 8.4516L12.2144 8.77927C12.6708 10.0147 13.6434 10.9887 14.8771 11.4458L15.2043 11.5671L14.8771 11.6883C13.6434 12.1454 12.6708 13.1195 12.2144 14.3549L12.0933 14.6825Z"
        stroke={color}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M16.5187 15.9558C16.3757 15.4853 16.008 15.117 15.5381 14.9738C16.008 14.8306 16.3757 14.4623 16.5187 13.9918C16.6617 14.4623 17.0294 14.8306 17.4993 14.9738C17.0294 15.117 16.6617 15.4853 16.5187 15.9558Z"
        stroke={color}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export default AISummaryIcon;
